import React from "react";
import swal from 'sweetalert2';

const Alerts = () => { }

export default Alerts;

Alerts.ShowAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
    });
}

Alerts.ShowAlertFullScreen = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        grow: "fullscreen"
    });
}


Alerts.SessionAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        buttons: false,
        closeOnEsc: false,
        closeOnClickOutside: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: false,
        allowOutsideClick: false
       
    });
}
